import { forwardRef } from "react";
import type { Theme } from "@mui/material";
import CustomScrollbars from "../CustomScrollbars";

export const clientAutocompletePaperProps: {
  paper: { elevation: number; sx: (theme: Theme) => object };
} = {
  paper: {
    elevation: 0,
    sx: (theme: Theme) => ({
      boxShadow: theme.shadows[12],
      border: "1px solid",
      borderColor: "divider",
    }),
  },
};

export const ClientAutocompleteListbox = forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>(function ClientAutocompleteListbox({ children, ...listboxProps }, ref) {
  return (
    <CustomScrollbars
      ref={ref}
      variant="compact"
      scrollableElement="ul"
      scrollableProps={listboxProps}
      trackOffsetTop={10}
      trackOffsetBottom={10}
      sx={{ width: "100%", minWidth: 0 }}
    >
      {children}
    </CustomScrollbars>
  );
});
